__turbopack_context__.v({
  "contentContainer": "SortDrawer-module__buvL5W__contentContainer",
  "drawerContent": "SortDrawer-module__buvL5W__drawerContent",
  "drawerTitle": "SortDrawer-module__buvL5W__drawerTitle",
  "isOpen": "SortDrawer-module__buvL5W__isOpen",
  "mobileDrawer": "SortDrawer-module__buvL5W__mobileDrawer",
  "option": "SortDrawer-module__buvL5W__option",
  "optionContent": "SortDrawer-module__buvL5W__optionContent",
  "options": "SortDrawer-module__buvL5W__options",
  "selected": "SortDrawer-module__buvL5W__selected",
});
